import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "toggle", "backdrop", "background"]

  connect() {
    this.viewport = window.matchMedia("(min-width: 768px)")
    this.desktopExpanded = false
    try {
      this.desktopExpanded = window.localStorage.getItem("primextate.sidebar.expanded") === "true"
    } catch (_) { /* Storage may be unavailable in private browsing. */ }
    this.onResize = () => {
      this.close()
      this.syncDesktop()
    }
    this.viewport.addEventListener("change", this.onResize)
    if (this.hasPanelTarget) {
      this.tooltipLinks = window.jQuery(this.panelTarget).find('[data-toggle="tooltip"]')
      this.tooltipLinks.on("show.bs.tooltip.sidebarMenu", event => {
        if (!this.viewport.matches || this.desktopExpanded) event.preventDefault()
      })
    }
    this.syncDesktop(false)
  }

  toggle() {
    if (!this.hasPanelTarget) return
    if (!this.viewport.matches) {
      this.isOpen ? this.close() : this.open()
      return
    }
    this.desktopExpanded = !this.desktopExpanded
    try {
      window.localStorage.setItem("primextate.sidebar.expanded", String(this.desktopExpanded))
    } catch (_) { /* The menu still works without persistence. */ }
    this.syncDesktop()
  }

  syncDesktop(animate = true) {
    if (!this.hasPanelTarget) return
    if (!animate) this.panelTarget.classList.add("is-restoring")
    this.panelTarget.classList.toggle("is-collapsed", !this.desktopExpanded)
    this.updateToggle(this.viewport.matches && this.desktopExpanded)
    if (!this.viewport.matches || this.desktopExpanded) this.tooltipLinks.tooltip("hide")
    if (!animate) {
      // Commit the restored width before enabling transitions for manual toggles.
      void this.panelTarget.offsetWidth
      this.panelTarget.classList.remove("is-restoring")
    }
  }

  updateToggle(expanded) {
    this.toggleTarget.setAttribute("aria-expanded", String(expanded))
    this.toggleTarget.setAttribute("aria-label", expanded ? "Close menu" : "Open menu")
    this.toggleTarget.setAttribute("title", expanded ? "Close menu" : "Open menu")
  }

  disconnect() {
    this.close()
    if (this.tooltipLinks) {
      this.tooltipLinks.tooltip("hide")
      this.tooltipLinks.off(".sidebarMenu")
    }
    this.viewport.removeEventListener("change", this.onResize)
  }

  open() {
    if (!this.hasPanelTarget || this.viewport.matches) return
    this.isOpen = true
    this.panelTarget.classList.add("is-mobile-open")
    this.panelTarget.setAttribute("role", "dialog")
    this.panelTarget.setAttribute("aria-modal", "true")
    this.panelTarget.setAttribute("aria-label", "Main menu")
    this.backdropTarget.hidden = false
    this.updateToggle(true)
    document.body.classList.add("mobile-menu-open")
    this.backgroundTargets.forEach(element => { element.inert = true })
    this.panelTarget.querySelector("button").focus()
  }

  close() {
    if (!this.isOpen) return
    this.isOpen = false
    this.panelTarget.classList.remove("is-mobile-open")
    ;["role", "aria-modal", "aria-label"].forEach(name => this.panelTarget.removeAttribute(name))
    this.backdropTarget.hidden = true
    this.updateToggle(this.viewport.matches && this.desktopExpanded)
    document.body.classList.remove("mobile-menu-open")
    this.backgroundTargets.forEach(element => { element.inert = false })
    if (!this.viewport.matches) this.toggleTarget.focus()
  }

  keydown(event) {
    if (!this.isOpen) return
    if (event.key === "Escape") {
      event.preventDefault()
      this.close()
    }
    if (event.key !== "Tab") return
    const controls = Array.from(this.panelTarget.querySelectorAll("a[href], button, input, select, textarea, [tabindex='0']"))
      .filter(element => !element.disabled && element.getClientRects().length)
    const first = controls[0]
    const last = controls[controls.length - 1]
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault()
      last.focus()
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault()
      first.focus()
    }
  }
}
